import styled from 'styled-components';

export const StyledPageContainer = styled.div`
  background: #fbfbfb !important;
  display: flex;
  min-height: 100vh;
  min-height: -webkit-fill-available;
  min-height: -moz-available;
  min-height: stretch;
  width: 100vw;
`;

export const StyledPagesContainer = styled.div`
  display: flex;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  margin: 12px 0;
  height: max-content;

  & img {
    pointer-events: none;
  }
`;
